import React, { useEffect, useRef } from 'react'
import IconModalClose from '~/assets/images/modal-close.svg'
import { useBreakpoint } from '~/hooks'
import { StyledFullPageModal, StyledFullPageModalContent } from './styled'
import { Props } from './types'

const FullPageModal: React.FC<Props> = ({
  visible,
  children,
  onClose,
  className = '',
  replace = false,
  showClose = true,
  hideBeacon = true,
}) => {
  const containerRef = useRef()
  const closeRef = useRef()
  const { isMobile } = useBreakpoint()
  const handleCloseModal = (event) => {
    const target = event.target
    const isCloseIconOrModal =
      target === closeRef.current || target === containerRef.current
    if (!isCloseIconOrModal) return
    onClose && onClose(event)
  }
  const setBeaconVisible = (visible) => {
    if (!isMobile) return
    const beacon = document.getElementById('beacon-container')
    if (beacon) {
      beacon.style.display = visible ? 'block' : 'none'
    }
  }

  useEffect(() => {
    if (hideBeacon) {
      setBeaconVisible(!visible)
    }
    return () => {
      setBeaconVisible(true)
    }
  }, [visible])

  if (!visible) return null

  if (replace) {
    return (
      <StyledFullPageModal ref={containerRef}>{children}</StyledFullPageModal>
    )
  }

  return (
    <StyledFullPageModal ref={containerRef}>
      <StyledFullPageModalContent className={className}>
        {showClose && (
          <img
            ref={closeRef}
            className="modal-close"
            src={IconModalClose}
            onClick={handleCloseModal}
          />
        )}
        {children}
      </StyledFullPageModalContent>
    </StyledFullPageModal>
  )
}

export default FullPageModal
